import { useState } from "react";
import useHelpers from "../../../../shared/services/helpers/useHelpers.hook";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import MuiIcon from "../../../../shared/styles/mui/helpers/mui-icon.helper";
import CreateSourceMapComponent from "./components/create-sourcemap/create-sourcemap.component";
import CreateSourceMapFormProvider from "../../../../shared/context/create-sourcemap/create-sourcemap-context";

interface IProps {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
}

export const sourceMap = [
  {
    label: "Source Detail",
    ordinal: 0,
    isOptional: false,
  },
  {
    label: "Create",
    ordinal: 1,
    isOptional: false,
  },
];

function CreateSourceMapDialogComponent({ open, onClose, onApply }: IProps) {
  const { hasDifference } = useHelpers();

  const [hasValidEditChanges, setHasValidEditChanges] =
    useState<boolean>(false);
  const [hasValidSaveChanges, setHasValidSaveChanges] =
    useState<boolean>(false);
  const [isPinned, setIsPinned] = useState<boolean>(false);

  return (
    <>
      {/* Filters Dialog */}
      <Dialog
        scroll="paper"
        maxWidth="lg"
        fullWidth
        fullScreen={isPinned}
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: { borderRadius: "12px", maxHeight: isPinned ? null : "640px" },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Grid container direction="row" wrap="nowrap">
            <Grid
              item
              alignItems="start"
              container
              direction="row"
              wrap="nowrap"
            >
              <Grid item container direction="column" wrap="nowrap">
                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="start"
                  alignItems="center"
                >
                  <Typography
                    color="text.secondary"
                    variant="button"
                    sx={{ textOverflow: "ellipsis" }}
                  >
                    Create Source Map
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              container
              direction="row"
              alignContent="start"
              justifyContent="center"
            >
              <Tooltip
                title={`${isPinned ? "Collapse" : "Expand"} Dialog`}
                placement="bottom"
              >
                <IconButton
                  onClick={() => setIsPinned(!isPinned)}
                  color="primary"
                  size="small"
                >
                  {isPinned
                    ? MuiIcon.FOLD({ sx: {} })
                    : MuiIcon.UN_FOLD({ sx: {} })}
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid
              item
              container
              direction="row"
              gap={1}
              justifyContent="end"
              wrap="nowrap"
              alignItems="center"
            >
              <IconButton
                color="primary"
                size="small"
                aria-label="close"
                onClick={onClose}
                sx={{ position: "absolute" }}
              >
                {MuiIcon.CLOSE()}
              </IconButton>
              {/* <Button color='error' variant='text' onClick={onClose} sx={{ mr: 2 }} startIcon={MuiIcon.CANCEL()}>Cancel</Button> */}
              {/* <MenuButtonComponent color='error' menuButtonColor='secondary' text='Cancel' onClick={onClose}
                                buttonIcon={MuiIcon.CANCEL()} size='small' variant='text'
                                buttonVariant={hasValidEditChanges ? 'outlined' : 'contained'}
                                menuButtonVariant={hasValidEditChanges ? 'contained' : 'outlined'}
                            > */}
              {/* <MenuItem onClick={handleResetFilters}>   */}
              {/* <ListItemIcon>{MuiIcon.RELOAD({ sx: { color: (t) => t.palette.error.main } })}</ListItemIcon>
                                    <ListItemText sx={{}}>Reset Filters</ListItemText>
                                </MenuItem>
                            </MenuButtonComponent> */}

              {/* <MenuButtonComponent color='primary' menuButtonColor='success' text='Apply' onClick={handleApply}
                                buttonIcon={MuiIcon.APPLY()} size='small' variant='text' buttonVariant='contained'
                                menuButtonVariant={hasValidSaveChanges && !hasValidEditChanges ? 'contained' : 'outlined'}
                                buttonDisabled={!hasValidEditChanges} menuButtonDisabled={!hasValidSaveChanges} >
                                <MenuItem onClick={() => saveFiltersLoader.loadAsync()}>
                                    <ListItemIcon color='success'>{MuiIcon.SAVE({ sx: { color: (t) => t.palette.success.dark } })}</ListItemIcon>
                                    <ListItemText sx={{ color: (t) => t.palette.success.dark }}>Save Filters</ListItemText>
                                </MenuItem>
                            </MenuButtonComponent> */}
            </Grid>
          </Grid>
        </DialogTitle>

        <Divider />

        <DialogContent sx={{ py: 4 }}>
          <CreateSourceMapFormProvider>
            <CreateSourceMapComponent data={sourceMap} onApply={onApply} />
          </CreateSourceMapFormProvider>
        </DialogContent>
      </Dialog>
    </>
  );
}
export default CreateSourceMapDialogComponent;
